const useGetSession = () => {
        const url = new URLSearchParams(window.location.search);
        return url.get("session");
}

export default useGetSession;